export function FormDataHandler<T extends { [key: string]: any }>(data: T) {
  const formData = new FormData()

  const keys = Object.keys(data)
  keys.forEach((key) => {
    try {
      formData.append(key, data[key])
    } catch (error) {
      console.error('Error: failed to append data to formData', {
        key,
        data: data[key],
      })
    }
  })

  return formData
}
